<div class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)' }" ngCloak>
    <div [ngStyle]="!hasBackdrop ? { 'box-sizing': 'content-box' } : {}" [ngClass]="hasBackdrop ? 'wallboardViewSlideContentAreaDark' : 'wallboardViewSlideContentAreaLight'">
        <div class="leaderboardHeader txtOverflow">{{leaderboardState?.LeaderboardTitle}} - {{leaderboardMetricName}}</div>

        <div class="leaderboardContent">
            <div class="leaderboardContentLeft">
                <div class="lRowHighlight"></div>

                <div class="leaderboardRow" *ngFor="let item of leaderboardData; let i = index">
                    <div [id]="'pos' + i" class="lPosition">{{displayPosition(i)}}</div>
                    <div [id]="'name' + i" class="lName txtOverflow">{{item.groupName}}</div>
                    <div [id]="'data' + i" class="lMetricData">{{item.metricData.MetricDisplayValue}}</div>
                </div>
            </div>

            <div class="leaderboardContentRight">
                <div class="lImageBackground">
                    <div class="lImage" style="width:89%; height:89%; background-position:center; background-repeat:no-repeat"
                         [ngStyle]="{ 'background-image': getUserImage(selectedAgent), 'background-size': getBackgroundSize() }"></div>
                </div>
            </div>
        </div>
    </div>
</div>
